import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/order/`;

const addNewOrder = async (payload) => {
  return await axios.post(API_URL + "create", payload);
};

const addSendOnlyNewOrder = async (payload) => {
  return await axios.post(API_URL + "sendonly/create", payload);
};

const getOrderLogs = async (orderId) => {
  return await axios.post(API_URL + "getlog", orderId);
}
const getPendingOrder = async (shop) => {
  return await axios.post(API_URL + "pendinggroup",{shop});
};

const getPendingPaymentSummaryQueue = async () => {
  return await axios.post(API_URL + "pending-payment-summary-queue", {});
};

const getPendingOrdersByCustomerId = async (payload) => {
  return await axios.post(API_URL + "pending-orders-by-customer", payload);
};

const markPaymentSummaryDone = async (payload) => {
  return await axios.post(API_URL + "mark-payment-summary-done", payload);
};
const getArrivalAcceptLists = async () => {
  return await axios.get(API_URL + "checkarrival");
};

const getLatestOrder = async (searchText) => {
  return await axios.post(API_URL, searchText);
};

const getNoTrackingOrder = async (formData) => {
  return await axios.post(API_URL + "notracking",formData);
};

const updateProcessOrder = async (uuid) => {
  return await axios.post(API_URL + "processupdate", {uuid});
};

const getAllProcessOrders = async (formData) => {
  return await axios.post(API_URL + "process", formData);
};

const getNoDeliveryFeeOrder = async (formData) => {
  return await axios.post(API_URL + "nodelivery", formData);
};

const updateOrder = async (order, userId) => {
  const config = {
    headers: {
      'x-user-id': userId,
    }
  };
  return await axios.patch(API_URL, order, config);
};

// Freshness read for the order editor: returns the current row so the client can
// detect a stale open form (compare updatedAt) before saving / on tab refocus.
const getOrderByUuid = async (uuid, shop) => {
  return await axios.get(API_URL + `by-uuid/${uuid}`, { params: { shop } });
};

const updateOrderStatus = async (formData) => {
  return await axios.post(API_URL + "status", formData);
};

const getOrderSummary = async (formData) => {
  return await axios.post(API_URL + "ordersummary", formData);
};

const getOrderSummaryByUrls = async (formData) => {
  return await axios.post(API_URL + "ordersummarybyurls", formData);
};

const collectInformCustomer = async (formData) => {
  return await axios.post(API_URL + "customercollectinform", formData);
};

const getOrdersFromSmileName = async (formData) => {
  console.log(formData)
  return await axios.post(API_URL + "profile/orderlist", formData);
};

const getOrderForWeeklyShipMatch = async (formData) => {
  return await axios.post(API_URL + "orderweeklyship", formData);
};

const updateTrackingJp = async (order, userId, mercariImages = null) => {
  const config = {
    headers: {
      'x-user-id': userId,
    },
  };

  const files = Array.isArray(mercariImages) ? mercariImages : (mercariImages ? [mercariImages] : []);
  if (files.length > 0) {
    const formData = new FormData();
    Object.entries(order).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
    });
    files.forEach((file) => formData.append('mercariImage', file));
    return await axios.patch(API_URL + "trackingjp", formData, config);
  }

  return await axios.patch(API_URL + "trackingjp", order, config);
};

const updateByLinkAndSmile = async (formData) => {
  return await axios.patch(API_URL + "linksmile", formData);
};

const arrivalAccept = async (formData) => {
  return await axios.post(API_URL + "arrivalaccept", formData);
};

const updateOrderAndUploadReceipt = async (formData) => {
  return await axios.post(API_URL + "updateproductpayment", formData);
};

/** Send event to backend so it appears in Render logs. Fire-and-forget so UI is not blocked; backend handler is minimal so server is not slowed. */
const logFrontendEvent = (payload) => {
  axios.post(API_URL + "log-frontend-event", payload).catch(() => {});
};

const getAmountFromUrl = async (formData) => {
  return await axios.post(API_URL + "amounturl", formData);
};

const deleteOrder = async (formData) => {
  return await axios.post(API_URL + "delete", formData);
};

const getBlacklistItems = async (customerId) => {
  return await axios.post(API_URL + "blacklistitem", {customerId});
};

const getOrderUrl = async (formData) => {
  return await axios.post(API_URL + "orderurl", formData);
};

const massUpdate = async (formData, userId) => {
  const config = {
    headers: {
      'x-user-id': userId, 
    }
  };
  return await axios.patch(API_URL + "mass",formData, config);
};

const getOrdersWithoutPurchaseConfirm = async (shop) => {
  return await axios.post(API_URL + "without-purchase-confirm", { shop });
};

const uploadPurchaseConfirmImage = async (formData) => {
  return await axios.post(API_URL + "upload-purchase-confirm", formData);
};

const getMercariOrderList = async (formData) => {
  return await axios.post(API_URL + "mercari-order-list", formData);
};

const markMercariOrderReceived = async (formData) => {
  return await axios.post(API_URL + `mercari-orders/received`, formData);
};

const addMercariCheckRecord = async (formData) => {
  return await axios.post(API_URL + "mercari-check-record", formData);
};

// Extra JP fee lines (e.g. mercari anshin appraisal) — charged with the first payment
const suggestExtraFees = async (url) => {
  return await axios.post(API_URL + "extra-fee/suggest", { url });
};

const addExtraFee = async ({ orderId, type, label, amountJpy }) => {
  return await axios.post(API_URL + "extra-fee", { orderId, type, label, amountJpy });
};

const removeExtraFee = async ({ orderId, type }) => {
  return await axios.post(API_URL + "extra-fee/remove", { orderId, type });
};

const createFirstOrderPaymentLink = async (formData) => {
  return await axios.post(API_URL + "create-first-payment-link", formData);
};

const createSecondOrderPaymentLink = async (formData) => {
  return await axios.post(API_URL + "create-second-payment-link", formData);
};

const checkExistingPaymentLink = async (formData) => {
  return await axios.post(API_URL + "check-existing-payment-link", formData);
};

const getPaymentIntentSummary = async (formData) => {
  return await axios.post(API_URL + "payment-intent-summary", formData);
};

const previewAdvancePayment = async (payload) => {
  return await axios.post(API_URL + "preview-advance-payment", payload);
};

const getOrdersBySmileNameAndUrls = async (formData) => {
  return await axios.post(API_URL + "orders-by-smile-name-and-urls", formData);
};

const createNonCompanySummaryCode = async (formData) => {
  return await axios.post(API_URL + "non-company-summary-code", formData);
};

const getSummaryByCode = async (code, shop) => {
  return await axios.get(API_URL + `summary-code/${code}`, { params: { shop } });
};

const createPrePaymentLink = async (formData) => {
  return await axios.post(API_URL + "create-pre-payment-link", formData);
};

const updateOrderImageAndConfirm = async (formData) => {
  return await axios.post(API_URL + "update-order-image-confirm", formData);
};

const getPendingBeamBeforePurchases = async (formData) => {
  return await axios.post(API_URL + "pending-beam-before-purchases", formData);
};

const cancelPendingBeamBeforePurchases = async (orderId) => {
  return await axios.post(API_URL + "cancel-pending-beam-before-purchases", { orderId });
};

const claimPendingBeam = async (orderId, takeover = false) => {
  return await axios.post(API_URL + "claim-pending-beam", { orderId, takeover });
};

const releasePendingBeam = async (orderId) => {
  return await axios.post(API_URL + "release-pending-beam", { orderId });
};

const getPendingBeamClaimCounts = async (shop) => {
  return await axios.post(API_URL + "pending-beam-claim-counts", { shop });
};

const markPendingBeamWaiting = async (orderId, orderByOptionId) => {
  return await axios.post(API_URL + "pending-beam-waiting", { orderId, orderByOptionId });
};

const cancelOrder = async (formData) => {
  return await axios.post(API_URL + "cancel", formData);
};

const getCancelledOrders = async (formData) => {
  return await axios.post(API_URL + "cancelled-orders", formData);
};

const processCancellation = async (formData) => {
  return await axios.post(API_URL + "process-cancellation", formData);
};

// Gain/North resolve a credit-card void-check: action 'voided' | 'reject'.
const resolveVoidCheck = async (orderId, action) => {
  return await axios.post(API_URL + "resolve-void-check", { orderId, action });
};

const claimCancelCase = async (payload) => {
  return await axios.post(API_URL + "claim-cancel-case", payload);
};

const releaseCancelCase = async (payload) => {
  return await axios.post(API_URL + "release-cancel-case", payload);
};

const getCancelClaimCounts = async (shop) => {
  return await axios.post(API_URL + "cancel-claim-counts", { shop });
};

const getHighValueWeeklyShipOrders = async (payload) => {
  return await axios.post(API_URL + "high-value-weeklyship", payload);
};

const getMercariPendingVerify = async (payload) => {
  return await axios.post(API_URL + "mercari-verify/pending", payload);
};

const updateMercariVerifyStatus = async (orderId, status) => {
  return await axios.patch(API_URL + `mercari-verify/${orderId}`, { status });
};

// The ส่งตรวจ leg of the same queue. Its own path because both legs of an ส่งตรวจ
// order share one Order.id — sending it to the order endpoint would approve the
// warehouse photo instead of the ส่งตรวจ one.
const updateAppraisalVerifyStatus = async (orderId, status) => {
  return await axios.patch(API_URL + `mercari-verify/appraisal/${orderId}`, { status });
};

const getMercariNotApproved = async () => {
  return await axios.get(API_URL + 'mercari-verify/not-approved');
};

const revertWebsiteFee = async (orderId) => {
  return await axios.post(API_URL + `${orderId}/revert-website-fee`);
};

const confirmOrderer = async ({ orderId, confirmedOrderByOptionId }) => {
  return await axios.post(API_URL + "confirm-orderer", { orderId, confirmedOrderByOptionId });
};

export default {
  addNewOrder,
  getPendingOrder,
  getPendingPaymentSummaryQueue,
  getPendingOrdersByCustomerId,
  markPaymentSummaryDone,
  getOrderByUuid,
  getNoTrackingOrder,
  getNoDeliveryFeeOrder,
  updateOrder,
  getOrderSummary,
  getOrderSummaryByUrls, // Add this new method
  updateTrackingJp,
  getOrderForWeeklyShipMatch,
  addSendOnlyNewOrder,
  getOrdersFromSmileName,
  getAmountFromUrl,
  updateByLinkAndSmile,
  updateOrderAndUploadReceipt,
  logFrontendEvent,
  getAllProcessOrders,
  getLatestOrder,
  deleteOrder,
  getOrderLogs,
  collectInformCustomer,
  massUpdate,
  updateProcessOrder,
  getArrivalAcceptLists,
  arrivalAccept,
  getBlacklistItems,
  getOrderUrl,
  updateOrderStatus,
  getOrdersWithoutPurchaseConfirm,
  uploadPurchaseConfirmImage,
  getMercariOrderList,
  markMercariOrderReceived,
  addMercariCheckRecord,
  suggestExtraFees,
  addExtraFee,
  removeExtraFee,
  createFirstOrderPaymentLink,
  createSecondOrderPaymentLink,
  checkExistingPaymentLink,
  getPaymentIntentSummary,
  previewAdvancePayment,
  getOrdersBySmileNameAndUrls,
  createPrePaymentLink,
  updateOrderImageAndConfirm,
  getPendingBeamBeforePurchases,
  cancelPendingBeamBeforePurchases,
  claimPendingBeam,
  releasePendingBeam,
  getPendingBeamClaimCounts,
  markPendingBeamWaiting,
  cancelOrder,
  getCancelledOrders,
  processCancellation,
  resolveVoidCheck,
  claimCancelCase,
  releaseCancelCase,
  getCancelClaimCounts,
  getHighValueWeeklyShipOrders,
  getMercariPendingVerify,
  updateMercariVerifyStatus,
  updateAppraisalVerifyStatus,
  getMercariNotApproved,
  revertWebsiteFee,
  createNonCompanySummaryCode,
  getSummaryByCode,
  confirmOrderer,
};
